









import { GPageBase } from '@/mixins';
import { mixins } from 'vue-class-component';
import { Component, Prop, Watch } from 'vue-property-decorator';
import GLoading from '@/components/GLoading.vue';
import { Competency } from '@/models/competency/competency';
import { eventGiftCourseModule } from '@/store/modules/frames/event-gift-course.module';
import { StatsCompetencyBoxplot } from '@/models/statistics/stats-competency-boxplot';
import { EventSurveyCompetencyGrowthTotal } from '@/models/jgrow/event';

interface competencyGrowthTableRow {
  [key: string]: string
}

@Component({
  name: 'GSurveyAnalyzeCompetencyTable',
  components: { GLoading },
})

export default class GSurveyAnalyzeCompetencyTable extends mixins(GPageBase) {
  mounted() {}

  get competencyGrowthTableColumns(): any[] {
    let cols: any[] = [];
    // 一番左の列を追加
    cols.push({
      title: '-',
      key: 'competency_name',
      width: 120,
      align: 'center',
      className: 'competency-growth-table-cell-0',
    });
    // コンピテンシーごとを列とする
    this.eventUseCompetencies.forEach((competency: Competency) => {
      cols.push({
        title: competency.name,
        key: 'competency_' + competency.competencyID,
        width: 120,
        align: 'center',
      });
    });
    return cols;
  }

  get competencyGrowthTableData(): any[] {
    let data: any[] = [];
    this.competencyGrowthTableSetupData.forEach((row: Map<string, EventSurveyCompetencyGrowthTotal>, compeID: string) => {
      let rowData: competencyGrowthTableRow = {};
      const found = this.eventUseCompetencies.find((comp: Competency) => {
        const tmpID = 'competency_' + comp.competencyID;
        if (tmpID === compeID) return comp;
      });
      rowData['competency_name'] = found.name;
      row.forEach((escgt: EventSurveyCompetencyGrowthTotal, colID: string) => {
        rowData[colID] = escgt.rate + '%';
      });
      data.push(rowData);
    });
    return data;
  }

  get eventUseCompetencies(): Competency[] {
    return eventGiftCourseModule.eventUseCompetencies;
  }

  get competencyGrowthTableSetupData() {
    return eventGiftCourseModule.competencyGrowthTableSetupData;
  }

  get beforeExamCompetencyBoxplots(): StatsCompetencyBoxplot[] {
    return eventGiftCourseModule.beforeExamCompetencyBoxplots;
  }

  get afterExamCompetencyBoxplots(): StatsCompetencyBoxplot[] {
    return eventGiftCourseModule.afterExamCompetencyBoxplots;
  }

  get loading(): boolean {
    return eventGiftCourseModule.loading;
  }
}
